import { Component } from '@angular/core';

@Component({
  templateUrl: './terms.component.html',
})
export class TermsComponent {

}



// WEBPACK FOOTER //
// ./src/app/marketing/terms.component.ts